import { URLS } from '@/pages/urls'
import { Text } from '@/ui-kit'
import { SquareArrowOutUpRight } from 'lucide-react'
import { Link } from 'react-router-dom'

const BENEFITS = [
  {
    title: 'Earn Airdrops',
    description: 'Receive standard SOL staking rewards and $DATA airdrops.'
  },
  {
    title: 'Unlock Extra Jobs',
    description: 'Access more tasks in your DataHive AI account.'
  },
  {
    title: 'Add Extra Devices',
    description: 'Connect additional workers to increase throughput and earn more points.'
  },
  {
    title: 'Boost Hive Points',
    description: 'Receive a higher multiplier on Hive points for platform activity.'
  }
]

export const StakingBenefits = () => {
  return (
    <div className="flex flex-col gap-6">
      <Text type="subtitle-semibold">Staking benefits</Text>

      <div className="flex flex-col gap-4">
        {BENEFITS.map((benefit) => (
          <div key={benefit.title} className="flex flex-col gap-1">
            <Text type="body1-regular" className="text-gray-70">
              {benefit.title}
            </Text>
            <Text type="body2-regular" className="text-gray-90">
              {benefit.description}
            </Text>
          </div>
        ))}
      </div>

      <div className="mt-6 border-t border-solid border-gray-100 pt-6">
        <Link
          className="group text-gray-70 flex items-center gap-2"
          to={URLS.BLOG_STAKING}
          target="_blank"
          rel="noreferrer"
        >
          <span className="group-hover:text-orange underline transition-colors duration-300">
            More information in our blog
          </span>
          <SquareArrowOutUpRight size={20} className="text-gray-90 group-hover:text-orange transition-colors duration-300" />
        </Link>
      </div>
    </div>
  )
}
